import { pick, setInputValue, selectRandomOption } from './helpers'

function dummyUsers () {
  return [
    { first_name: 'Alice', last_name: 'Thornton', password: 'password123' },
    { first_name: 'Marcus', last_name: 'Chen', password: 'password123' },
    { first_name: 'Priya', last_name: 'Kapoor', password: 'password123' },
    { first_name: 'Oliver', last_name: 'Dubois', password: 'password123' },
    { first_name: 'Sofia', last_name: 'Andersson', password: 'password123' }
  ]
}

function dummyTradeDetails () {
  return [
    { phone: '07911123456', company: 'Thornton Interiors Ltd', website: 'https://thorntoninteriors.co.uk', project: 'Boutique hotel refurbishment in Shoreditch, 42 rooms requiring unique vintage furniture pieces for each.' },
    { phone: '07412345678', company: 'Chen Design Studio', website: 'https://chendesign.com', project: 'High-end residential project in Kensington, sourcing mid-century modern pieces for a five-bedroom townhouse renovation.' },
    { phone: '07523456789', company: 'Kapoor & Partners Architecture', website: 'https://kapoorpartners.co.uk', project: 'Commercial office fit-out in Manchester, looking for statement vintage furniture for reception and meeting spaces.' },
    { phone: '07634567890', company: 'Maison Dubois', website: 'https://maisondubois.com', project: 'Restaurant interior design in Edinburgh, sourcing Art Deco and mid-century dining furniture for a 60-cover venue.' },
    { phone: '07745678901', company: 'Nordic Living Spaces', website: 'https://nordiclivingspaces.co.uk', project: 'Serviced apartments in Bristol, furnishing 12 units with curated Scandinavian vintage pieces.' }
  ]
}

function fillCoreFields (user) {
  setInputValue('#vjs-user-account-attributes-first-name', user.first_name)
  setInputValue('#vjs-user-account-attributes-last-name', user.last_name)
  setInputValue('#vjs-user-password', user.password)
  selectRandomOption('vjs-user-acquisition-channel')
}

function fillConsumerFields () {
  const tradeCheckbox = document.getElementById('vjs-trade-form')
  if (tradeCheckbox && tradeCheckbox.checked) {
    tradeCheckbox.click()
  }

  selectRandomOption('vjs-user-registration-driver')
  selectRandomOption('vjs-user-registration-vintage-affinity')
}

function fillTradeFields (trade) {
  const tradeCheckbox = document.getElementById('vjs-trade-form')
  if (!tradeCheckbox) return

  if (!tradeCheckbox.checked) {
    tradeCheckbox.click()
  }

  setInputValue('#vjs-user-account-attributes-phone-number', trade.phone)
  setInputValue('#vjs-user-trade-buyer-account-attributes-company-name', trade.company)
  setInputValue('#vjs-user-trade-buyer-account-attributes-website', trade.website)
  setInputValue('#vjs-user-trade-buyer-account-attributes-current-project', trade.project)
  selectRandomOption('vjs-user-trade-buyer-account-attributes-business-type')
  selectRandomOption('vjs-user-trade-buyer-account-attributes-company-spend')

  const marketingCheckbox = document.getElementById('vjs-user-marketing-opt-in')
  if (marketingCheckbox && !marketingCheckbox.checked) marketingCheckbox.click()
}

export default function initRegistrationDevAutofill () {
  const form = document.querySelector('.vjs-registration-form')
  if (!form) return

  const consumerBtn = document.querySelector('.vjs-registration-autofill')
  const tradeBtn = document.querySelector('.vjs-registration-autofill-trade')

  if (consumerBtn) {
    consumerBtn.addEventListener('click', () => {
      const user = pick(dummyUsers())
      fillCoreFields(user)
      fillConsumerFields()
    })
  }

  if (tradeBtn) {
    tradeBtn.addEventListener('click', () => {
      const user = pick(dummyUsers())
      const trade = pick(dummyTradeDetails())
      fillCoreFields(user)
      fillTradeFields(trade)
    })
  }
}
